export default {"src":"/_next/static/image/public/images/flags/flag_55.7b33cdcbee16680353851f562ad0374b.svg","height":16,"width":24};